import React from 'react'

import IconVocabulary from '../assets/icons/IconVocabulary'
import IconPractice from '../assets/icons/IconPractice'
import IconStudy from '../assets/icons/IconStudy'
import IconDialogue from '../assets/icons/IconDialogue'
import IconText from '../assets/icons/IconText'
import IconListen from '../assets/icons/IconListen'
import IconQuiz from '../assets/icons/IconQuiz'
import IconAlphabet from '../assets/icons/IconAlphabet'


export const STAGES_INFO = [
    {
        name: 'Vocabulary',
        icon: <IconVocabulary color={'white'}/>,
        iconDone: <IconVocabulary color={'black'}/>,
    },
    {
        name: 'Practice',
        icon: <IconPractice color={'white'} />,
        iconDone: <IconPractice color={'black'} />,
    },
    {
        name: 'Study',
        icon: <IconStudy color={'white'}/>,
        iconDone: <IconStudy color={'black'}/>,
    },
    {
        name: 'Dialog',
        icon: <IconDialogue color={'white'}/>,
        iconDone: <IconDialogue color={'black'}/>,
    },
    {
        name: 'Text',
        icon: <IconText color={'white'}/>,
        iconDone: <IconText color={'black'}/>,
    },
    {
        name: 'Listen',
        icon: <IconListen color={'white'}/>,
        iconDone: <IconListen color={'black'}/>,
    },
    {
        name: 'Quiz',
        icon: <IconQuiz color={'white'}/>,
        iconDone: <IconQuiz color={'black'}/>,
    },
    {
        name: 'Alphabet',
        icon: <IconAlphabet color={'white'}/>,
        iconDone: <IconAlphabet color={'black'}/>,
    },
]